import Vue from 'vue';
import { Module, ActionContext } from 'vuex';
import ajax from '@/lib/ajaxFiling';
import store from '@/store/index';

interface ImageManagerState {
    imageUrl: String;
}

class ImageManagerModule implements Module<ImageManagerState, any>{
    namespaced = true;
    state = {
        imageUrl: ""
    }
    actions = {
        async deleteImage(context: ActionContext<ImageManagerState, any>, payload: any) {
            const Ajax = ajax.create((store.state as Vue & { session: () => any }).session);
            await Ajax.delete('/oss/delete?imageUrl=' + payload.data.imageUrl);
        },
        // Used in HTML editors which need to upload image function
        async uploadImage(context: ActionContext<ImageManagerState, any>, payload: any) {
            const Ajax = ajax.create((store.state as Vue & { session: () => any }).session);
            let reponse = await Ajax.post('/oss/upload?usage=Product', payload.data, { headers: { 'Content-Type': 'multipart/form-data' } });
            var result = reponse.data.result.location;
            return result;
        }
    };
    mutations = {

    }
}
const imageManagerModule = new ImageManagerModule();
export default imageManagerModule;